<template lang="pug">
    include RegisterStep2.pug
</template>

<script>
import _ from "underscore";
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: 'RegisterStep2',
  data() {
    return {
      name: '',
      lastname1: '',
      lastname2: '',
      phone: "",
      email: "",
    }
  },
  computed: _.extend(mapState([
    "context", "token", "type",
  ]), {
    valid: function() {
      if (_.isEmpty(this.name)) return false
      if (_.isEmpty(this.lastname1)) return false
      if (_.isEmpty(this.lastname2)) return false
      if (_.isEmpty(this.phone)) return false
      return true
    },
  }),
  async created() {
    // store me information - with token
    const meResponse = await Api.me(this.token)
    const data = meResponse.data
    this.email = data.email
  },
  methods: {
    async save() {
      const data = {
        first_name: this.name,
        last_name: `${this.lastname1} ${this.lastname2}`,
        token: this.token,
        phone: this.phone,
      }
      const response = await Api.updateAccount(data)

      this.$router.push({
        name: "RegisterStep3",
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "RegisterStep1";
@import "RegisterStep2";
</style>



// WEBPACK FOOTER //
// src/components/register/RegisterStep2.vue